import { DialogService } from 'primeng/dynamicdialog';
import { IBaseResponse } from '../../models/comm-http/responses/BaseResponse';
import { KeyValuePairArray } from '../../models/KeyValuePair';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { xToastr, ToastrTypes } from '../../shared/Toastr';

import { IErrorEventArgs } from 'app/models/event-args/global-error.event.args';
import { CompleteOrderDialogComponent } from 'app/dialogs/complete-order/complete-order-dialog.component';
import { AddCreditCardDialogComponent } from 'app/dialogs/add-credit-card/add-credit-card-dialog.component';
import { Title, Meta } from '@angular/platform-browser';
import { GlobalServices } from 'app/services/global.service';

export enum FormTypes {
    SigninForm = 0,
    SigninFormTest = 1,
    TwoFactorChoiceForm = 2,
    TwoFactorCodeForm = 3,
    ForgotPasswordForm = 4,
    Redirect = 5,
    Locked = 6
}

@Component({
    selector: 'signin',
    templateUrl: './signin.component.html',
    styleUrls: ['./signin.component.css'],
    providers: [DialogService]
})
export class SigninComponent implements OnInit, OnDestroy {

    private RedirectTo: string;

    TwoFactorOptions: KeyValuePairArray<string, string>;
    IsBusy: boolean = false;

    IsWelcomeBack: boolean = false;

    // DATA SUBSCRIPTION VARIABLES
    paramsSubscribe: any;
    routeParams: object;

    SelectedForm: FormTypes = FormTypes.SigninForm;


    constructor(private router: Router,
        private dialogService: DialogService,
        private route: ActivatedRoute,
        private gb : GlobalServices ) {
        // subscribe and add to list
        this.ShowForm(FormTypes.SigninForm);
        this.paramsSubscribe = this.route.params.subscribe(params => this.routeParams = params);
    }

    ngOnDestroy() {
        this.paramsSubscribe.unsubscribe();
    }

    ngOnInit() {
        
        //this.titleService.setTitle("Member Login | Structure Studios");
        //this.meta.updateTag();
        
        this.gb.SetPageTitle( "Login", "Existing Members login page to manage their account." )
        
        // Remove email from localstorage if it exists
        localStorage.removeItem('email');

        if (this.routeParams['welcomeBack'] != undefined) {
            this.IsWelcomeBack = true;
        } else if (this.route.snapshot.queryParams['forgotPassword'] != undefined) {
            this.SelectedForm = FormTypes.ForgotPasswordForm;
        } else if (this.routeParams['token'] != undefined) {
            this.dialogService.open(AddCreditCardDialogComponent, {});
        }
    }

    ShowForm(form: FormTypes) {

        this.SelectedForm = form;
    }


    onBusyChanged(isBusy: boolean) {
        this.IsBusy = isBusy;
    }

    onAuthenticated(ev: IBaseResponse<any>) {
        this.ShowForm(FormTypes.Redirect);
        console.log('On Authenticated!');

        setTimeout(() => {
            let redirect = localStorage.getItem('loginRedirect');

            if (redirect) {
                this.router.navigate([redirect]);
            } else {
                if (ev.Redirect != null)
                    this.router.navigate([ev.Redirect]);
                else
                    this.router.navigate(['account/product-memberships']);
            }

        }, 2500);

    }

    onTwoFactorRequired(twoFactorOptions: KeyValuePairArray<string, string>) {
        this.TwoFactorOptions = twoFactorOptions;
        this.ShowForm(FormTypes.TwoFactorChoiceForm);
    }

    onTwoFactorCodeSent() {
        this.ShowForm(FormTypes.TwoFactorCodeForm);
    }

    onForgotPassword() {
        this.ShowForm(FormTypes.ForgotPasswordForm);
    }

    onForgotPasswordCancel() {
        this.ShowForm(FormTypes.SigninForm);
    }

    onLocked() {
        this.ShowForm(FormTypes.Locked);
    }

    onUnfinishedOrder(ufoid: string) {

        console.log('Unfinished Order!');

        this.dialogService.open(CompleteOrderDialogComponent, {data: {
            UFOID: ufoid,
            fromLogin: false
        }});

    }

    onError(ev: IErrorEventArgs) {
        xToastr.ShowToast(ToastrTypes.Error, ev.FriendlyErrorTitle, ev.FriendlyErrorMessage);

        if (this.SelectedForm == FormTypes.TwoFactorChoiceForm)
            this.ShowForm(FormTypes.SigninForm);
    }

    onCancel() {

        if (this.SelectedForm == FormTypes.TwoFactorChoiceForm)
            this.ShowForm(FormTypes.SigninForm);
        else if (this.SelectedForm == FormTypes.TwoFactorCodeForm)
            this.ShowForm(FormTypes.TwoFactorChoiceForm);
        else
            this.ShowForm(FormTypes.SigninForm);
    }

}
